import axios from 'axios'

const AxiosClient = axios.create({
  baseURL: process.env.VUE_APP_CS_EXTERNAL_BASE_URL,
  headers: {
    'x-api-key': process.env.VUE_APP_CS_EXTERNAL_API_KEY
  }
})

AxiosClient.interceptors.request.use(config => {
  if (!config.headers) {
    config.headers = {}
  }

  config.headers.organization = config.headers.organization || 'MOBLY'

  return config
})

export default AxiosClient
